// @flow
import React from 'react';
import Tooltip from 'common/components/core/tooltip';
import overflowDetectorFactory from 'common/components/core/util/OverflowDetector';
import Div from './Div';

const TooltipDiv = Tooltip(Div);
export default TooltipDiv;

const TooltipWithOverflow = ({
    tooltip,
    textOverflow,
    forceShowTooltip,
    ...others
}) => {
    return (
        <TooltipDiv
            tooltip={textOverflow || forceShowTooltip ? tooltip : null}
            {...others}
        />
    );
};

export const TooltipDivOverflow = overflowDetectorFactory({
    WrappedComponent: TooltipWithOverflow
});
